import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* React Router preserves scroll position across route changes by default.
   Mount this once inside <Router> so any navigation lands the user at the
   top of the new page. */
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname]);

    return null;
};

export default ScrollToTop;
